import { useController, useFormContext } from 'react-hook-form';
import Box from '@/components/UI/Box';
import DateTimePicker from '../Custom/DateTimePicker';
import type { EventEditFormValues } from './EventEdit.types';

function EventEditDatetime() {
  const { trigger, control } = useFormContext<EventEditFormValues>();
  const { field } = useController({
    name: 'datetime',
    control,
  });
  const handleDateTimeChange = (value: string | null) => {
    field.onChange(value);
    trigger();
  };
  return (
    <Box direction="vertical">
      <DateTimePicker
        value={field.value}
        onChange={handleDateTimeChange}
        onBlur={field.onBlur}
        minuteInterval={5}
        testID="event-datetime"
      />
    </Box>
  );
}
export default EventEditDatetime;
